module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('div', {
    staticClass: "cr-page"
  }, [_c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("New Race")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Create a scheduled LiveRun session with stream, media and participant settings")])]), _vm._v(" "), _c('router-link', {
    staticClass: "cr-ghost-btn",
    attrs: {
      "to": "/admin/races",
      "id": "Cancel"
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 12H5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 19l-7-7 7-7"
    }
  })]), _vm._v("\n        Races\n      ")])], 1), _vm._v(" "), _c('custom-form', {
    staticClass: "cr-form",
    attrs: {
      "handle-submit": _vm.handleSubmit
    }
  }, [_c('section', {
    staticClass: "cr-card"
  }, [_c('div', {
    staticClass: "cr-card-header"
  }, [_c('span', {
    staticClass: "cr-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 6h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 12h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 18h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 6h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 12h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 18h.01"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "cr-card-title"
  }, [_vm._v("Race Details")]), _vm._v(" "), _c('p', {
    staticClass: "cr-card-sub"
  }, [_vm._v("Name, description, timing and base capacity for the session")])])]), _vm._v(" "), _c('div', {
    staticClass: "cr-grid cr-grid--two"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "cr-field",
    attrs: {
      "label": "Name",
      "name": "name",
      "maxlength": "5",
      "data-vv-value-path": "input",
      "data-vv-name": "name",
      "error-message": "Fill in the name",
      "has-error": _vm.errors.has('name'),
      "required": true
    },
    model: {
      value: (_vm.race.name),
      callback: function($$v) {
        _vm.$set(_vm.race, "name", $$v)
      },
      expression: "race.name"
    }
  }), _vm._v(" "), _c('date-time-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "cr-field",
    attrs: {
      "label": ("Date - " + (_vm.getTimezone())),
      "name": "date",
      "data-vv-value-path": "startDate.time",
      "data-vv-name": "date",
      "error-message": "Fill in the date",
      "has-error": _vm.errors.has('date'),
      "required": true
    },
    model: {
      value: (_vm.race.date),
      callback: function($$v) {
        _vm.$set(_vm.race, "date", $$v)
      },
      expression: "race.date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__group cr-field cr-field--full"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.race.description),
      expression: "race.description"
    }],
    class: {
      'form-control': true,
      'is-danger': _vm.errors.has('description')
    },
    attrs: {
      "data-vv-rules": "required",
      "name": "description",
      "rows": "6",
      "id": "txtArea",
      "required": ""
    },
    domProps: {
      "value": (_vm.race.description)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.onDescriptionChange.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.race, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('description')),
      expression: "errors.has('description')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the description")])]), _vm._v(" "), _c('div', {
    staticClass: "form__group cr-field"
  }, [_c('label', {
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Duration in minutes "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.race.duration),
      expression: "race.duration"
    }],
    class: {
      'form-control': true,
      'is-danger': _vm.errors.has('duration')
    },
    attrs: {
      "data-vv-rules": "required",
      "type": "number",
      "step": "1",
      "min": "1",
      "max": _vm.max_duration,
      "name": "duration",
      "required": ""
    },
    domProps: {
      "value": (_vm.race.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.race, "duration", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('duration')),
      expression: "errors.has('duration')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the duration")])]), _vm._v(" "), _c('div', {
    staticClass: "form__group cr-field"
  }, [_c('label', {
    attrs: {
      "for": "rsvp_limit"
    }
  }, [_vm._v("RSVP Limit "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.race.rsvp_limit),
      expression: "race.rsvp_limit"
    }],
    class: {
      'form-control': true,
      'is-danger': _vm.errors.has('rsvp_limit')
    },
    attrs: {
      "data-vv-rules": "required",
      "type": "number",
      "step": "1",
      "min": "1",
      "max": _vm.max_rsvp_limit,
      "name": "rsvp_limit",
      "required": ""
    },
    domProps: {
      "value": (_vm.race.rsvp_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.race, "rsvp_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rsvp_limit')),
      expression: "errors.has('rsvp_limit')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the RSVP limit")])])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "cr-card"
  }, [_c('div', {
    staticClass: "cr-card-header cr-card-header--split"
  }, [_c('div', {
    staticClass: "cr-card-heading"
  }, [_c('span', {
    staticClass: "cr-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 1l4 4-4 4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 11V9a4 4 0 0 1 4-4h14"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 23l-4-4 4-4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 13v2a4 4 0 0 1-4 4H3"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "cr-card-title"
  }, [_vm._v("Repeat Schedule")]), _vm._v(" "), _c('p', {
    staticClass: "cr-card-sub"
  }, [_vm._v("Optionally generate recurring race sessions from this setup")])])]), _vm._v(" "), _c('div', {
    staticClass: "cr-toggle-wrap"
  }, [_c('span', {
    staticClass: "mode-env-badge"
  }, [_vm._v(_vm._s(_vm.isRepeatShift ? 'Repeating' : 'One time'))]), _vm._v(" "), _c('lv-toggle', {
    on: {
      "change": _vm.onChecked
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.isRepeatShift),
      callback: function($$v) {
        _vm.isRepeatShift = $$v
      },
      expression: "isRepeatShift"
    }
  })], 1)]), _vm._v(" "), (_vm.isRepeatShift) ? _c('div', {
    staticClass: "cr-repeat-grid"
  }, [_c('div', {
    staticClass: "form__group cr-field"
  }, [_c('label', {
    attrs: {
      "for": "repeatDays"
    }
  }, [_vm._v("Repeat Every "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.race.interval),
      expression: "race.interval"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.isRepeatShift ? 'required' : ''),
      expression: "isRepeatShift?'required':''"
    }],
    staticClass: "cr-select",
    attrs: {
      "name": "repeatDays",
      "required": _vm.isRepeatShift
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.race, "interval", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "EVERY_WEEK"
    }
  }, [_vm._v("Every Week")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EVERY_2_WEEKS"
    }
  }, [_vm._v("Every 2 Weeks")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EVERY_MONTH"
    }
  }, [_vm._v("Every Month")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('repeatDays')),
      expression: "errors.has('repeatDays')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the Repeat Days")])]), _vm._v(" "), _c('date-time-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.isRepeatShift ? 'required' : ''),
      expression: "isRepeatShift?'required':''"
    }],
    staticClass: "cr-field endingDate",
    attrs: {
      "isRepeatField": true,
      "name": "endDate",
      "data-vv-value-path": "startDate.time",
      "data-vv-name": "endDate",
      "error-message": "Fill in the End date",
      "has-error": _vm.errors.has('endDate'),
      "data-vv-rules": _vm.isRepeatShift ? 'required' : '',
      "required": _vm.isRepeatShift
    },
    model: {
      value: (_vm.race.end_interval),
      callback: function($$v) {
        _vm.$set(_vm.race, "end_interval", $$v)
      },
      expression: "race.end_interval"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "cr-card"
  }, [_c('div', {
    staticClass: "cr-card-header"
  }, [_c('span', {
    staticClass: "cr-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 4h16v16H4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 9h16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 20V9"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "cr-card-title"
  }, [_vm._v("Type And Stream")]), _vm._v(" "), _c('p', {
    staticClass: "cr-card-sub"
  }, [_vm._v("Choose medal behavior, category labels, language and audio channel")])])]), _vm._v(" "), _c('div', {
    staticClass: "cr-grid cr-grid--two"
  }, [_c('div', {
    staticClass: "form__group cr-field"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("First Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.race.type),
      expression: "race.type"
    }],
    staticClass: "cr-select",
    attrs: {
      "label": "First Type",
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.race, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "LIVE"
    }
  }, [_vm._v("Live (Medal)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NO_MEDAL"
    }
  }, [_vm._v("No Medal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ON_DEMAND_MEDAL"
    }
  }, [_vm._v("On demand (Medal)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ON_DEMAND_NO_MEDAL"
    }
  }, [_vm._v("On demand (No Medal)")])])]), _vm._v(" "), (_vm.race.type == 'ON_DEMAND_MEDAL' || _vm.race.type == 'ON_DEMAND_NO_MEDAL') ? _c('race-media', {
    staticClass: "cr-field",
    attrs: {
      "label": "On demand File",
      "name": "media",
      "data-vv-value-path": "input",
      "data-vv-name": "media",
      "error-message": "Fill in the audio",
      "has-error": _vm.errors.has('media'),
      "required": false
    },
    model: {
      value: (_vm.race.audioFileUrl),
      callback: function($$v) {
        _vm.$set(_vm.race, "audioFileUrl", $$v)
      },
      expression: "race.audioFileUrl"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form__group cr-field"
  }, [_c('label', {
    attrs: {
      "for": "secondType"
    }
  }, [_vm._v("Second Type")]), _vm._v(" "), (_vm.raceTypesLoading) ? _c('div', {
    staticClass: "cr-sk-input sk-shimmer"
  }) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.race.secondType),
      expression: "race.secondType"
    }],
    staticClass: "cr-select",
    attrs: {
      "label": "Second Type",
      "name": "secondType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.race, "secondType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.raceTypes), function(type) {
    return _c('option', {
      key: type.name,
      domProps: {
        "value": type.name
      }
    }, [_vm._v(_vm._s(type.englishText))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form__group cr-field"
  }, [_c('label', {
    attrs: {
      "for": "thirdType"
    }
  }, [_vm._v("Third Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.race.thirdType),
      expression: "race.thirdType"
    }],
    staticClass: "cr-select",
    attrs: {
      "label": "Third Type",
      "name": "thirdType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.race, "thirdType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("NONE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NO_MEDAL"
    }
  }, [_vm._v("NO MEDAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoL"
    }
  }, [_vm._v("L")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoI"
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoV"
    }
  }, [_vm._v("V")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoE"
    }
  }, [_vm._v("E")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LIVE_60MIN"
    }
  }, [_vm._v("60MIN_MEDAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoU"
    }
  }, [_vm._v("U")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoR"
    }
  }, [_vm._v("R")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MEDAL_20K"
    }
  }, [_vm._v("20Km Medal")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__group cr-field"
  }, [_c('label', {
    attrs: {
      "for": "channel"
    }
  }, [_vm._v("Channel")]), _vm._v(" "), (_vm.channelsLoading) ? _c('div', {
    staticClass: "cr-sk-input sk-shimmer"
  }) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.race.mobileChannelToPlay),
      expression: "race.mobileChannelToPlay"
    }],
    staticClass: "cr-select",
    attrs: {
      "label": "Channel",
      "name": "channel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.race, "mobileChannelToPlay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.channels.audioChannelA
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.channels.audioChannelB
    }
  }, [_vm._v("B")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.channels.audioChannelC
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.channels.audioChannelD
    }
  }, [_vm._v("D")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__group cr-field"
  }, [_c('label', {
    attrs: {
      "for": "language"
    }
  }, [_vm._v("Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.race.language),
      expression: "race.language"
    }],
    staticClass: "cr-select",
    attrs: {
      "label": "Language",
      "name": "language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.race, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.locales), function(locale) {
    return _c('option', {
      key: locale.id,
      domProps: {
        "value": locale.id
      }
    }, [_vm._v(_vm._s(locale.name))])
  }), 0)])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "cr-card"
  }, [_c('div', {
    staticClass: "cr-card-header"
  }, [_c('span', {
    staticClass: "cr-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 13a5 5 0 0 0 7.07 0l2.83-2.83a5 5 0 0 0-7.07-7.07L11.5 4.43"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14 11a5 5 0 0 0-7.07 0L4.1 13.83a5 5 0 0 0 7.07 7.07l1.33-1.33"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "cr-card-title"
  }, [_vm._v("Action Link")]), _vm._v(" "), _c('p', {
    staticClass: "cr-card-sub"
  }, [_vm._v("Configure the end-session URL and optional action image")])])]), _vm._v(" "), _c('div', {
    staticClass: "cr-grid cr-grid--two"
  }, [_c('div', {
    staticClass: "cr-field"
  }, [_c('label', {
    staticClass: "cr-label",
    attrs: {
      "for": "endSessionUrl"
    }
  }, [_vm._v("Action URL")]), _vm._v(" "), _c('text-field', {
    attrs: {
      "name": "endSessionUrl",
      "data-vv-value-path": "input",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.race.endSessionUrl),
      callback: function($$v) {
        _vm.$set(_vm.race, "endSessionUrl", $$v)
      },
      expression: "race.endSessionUrl"
    }
  })], 1), _vm._v(" "), _c('race-photo', {
    staticClass: "cr-field",
    attrs: {
      "label": "Action Image",
      "name": "actionImage",
      "data-vv-value-path": "input",
      "data-vv-name": "actionImage",
      "error-message": "Fill in the photo with size below 200 Kb",
      "has-error": _vm.errors.has('actionImage'),
      "required": false
    },
    model: {
      value: (_vm.race.actionImageUrl),
      callback: function($$v) {
        _vm.$set(_vm.race, "actionImageUrl", $$v)
      },
      expression: "race.actionImageUrl"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "cr-card"
  }, [_c('div', {
    staticClass: "cr-card-header cr-card-header--split"
  }, [_c('div', {
    staticClass: "cr-card-heading"
  }, [_c('span', {
    staticClass: "cr-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 7h.01"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "cr-card-title"
  }, [_vm._v("Tags And Trainer")]), _vm._v(" "), _c('p', {
    staticClass: "cr-card-sub"
  }, [_vm._v("Assign audience tags, club randomization and the trainer owner")])])]), _vm._v(" "), _c('div', {
    staticClass: "cr-toggle-wrap"
  }, [_c('span', {
    staticClass: "mode-env-badge"
  }, [_vm._v(_vm._s(_vm.race.randomClubTag ? 'Club tag on' : 'Club tag off'))]), _vm._v(" "), _c('lv-toggle', {
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.race.randomClubTag),
      callback: function($$v) {
        _vm.$set(_vm.race, "randomClubTag", $$v)
      },
      expression: "race.randomClubTag"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cr-grid cr-grid--two"
  }, [_c('div', {
    staticClass: "form__group cr-field race-tags"
  }, [_c('label', {
    attrs: {
      "for": "tags"
    }
  }, [_vm._v("Tags")]), _vm._v(" "), (_vm.tagsLoading) ? _c('div', {
    staticClass: "cr-sk-input sk-shimmer"
  }) : _c('selectize', {
    staticClass: "cr-selectize-hidden",
    attrs: {
      "options": _vm.tagsOptions,
      "multiple": "",
      "size": "1",
      "isRunnerTag": false,
      "data-dropdown-parent": "body",
      "data-max-options": "100",
      "data-value-field": "id",
      "data-label-field": "name",
      "data-search-field": "name",
      "data-sort-field": "name"
    },
    model: {
      value: (_vm.selectedTags),
      callback: function($$v) {
        _vm.selectedTags = $$v
      },
      expression: "selectedTags"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form__group cr-field"
  }, [_c('label', {
    attrs: {
      "for": "Trainer"
    }
  }, [_vm._v("Trainer")]), _vm._v(" "), (_vm.trainerLoading) ? _c('div', {
    staticClass: "cr-sk-input sk-shimmer"
  }) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trainerId),
      expression: "trainerId"
    }],
    staticClass: "cr-select trainer-list",
    attrs: {
      "label": "Trainer",
      "name": "Trainer"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trainerId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeTrainer]
    }
  }, _vm._l((_vm.trainerList), function(trainer, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": trainer.id
      }
    }, [_vm._v(_vm._s(trainer.firstName))])
  }), 0)])])]), _vm._v(" "), _c('section', {
    staticClass: "cr-card"
  }, [_c('div', {
    staticClass: "cr-card-header"
  }, [_c('span', {
    staticClass: "cr-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "3",
      "width": "18",
      "height": "18",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "8.5",
      "cy": "8.5",
      "r": "1.5"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "21 15 16 10 5 21"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "cr-card-title"
  }, [_vm._v("Race Photo")]), _vm._v(" "), _c('p', {
    staticClass: "cr-card-sub"
  }, [_vm._v("Upload the required image shown with this race in the mobile app")])])]), _vm._v(" "), _c('div', {
    staticClass: "cr-photo-grid"
  }, [(_vm.race.imageUrl) ? _c('div', {
    staticClass: "cr-photo-preview"
  }, [_c('span', {
    staticClass: "cr-photo-label"
  }, [_vm._v("Current race photo")]), _vm._v(" "), _c('img', {
    staticClass: "cr-photo-img",
    attrs: {
      "src": _vm.race.imageUrl,
      "alt": "Current race photo"
    }
  })]) : _vm._e(), _vm._v(" "), _c('upload-photo', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "cr-field",
    attrs: {
      "label": "Photo",
      "name": "photo",
      "data-vv-value-path": "input",
      "data-vv-name": "photo",
      "error-message": "Fill in the photo with size below 200 Kb",
      "has-error": _vm.errors.has('photo'),
      "required": true
    },
    model: {
      value: (_vm.race.imageUrl),
      callback: function($$v) {
        _vm.$set(_vm.race, "imageUrl", $$v)
      },
      expression: "race.imageUrl"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cr-actions"
  }, [_c('router-link', {
    staticClass: "cr-ghost-btn",
    attrs: {
      "to": "/admin/races"
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "cr-primary-btn",
    attrs: {
      "id": "submit-form",
      "disabled": _vm.isSubmitting
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "17 21 17 13 7 13 7 21"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "7 3 7 8 15 8"
    }
  })]), _vm._v("\n          " + _vm._s(_vm.isSubmitting ? 'Creating...' : 'Create Race') + "\n        ")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2780993e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Races/Create.vue
// module id = 1686
// module chunks = 2